module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g7ucD"))).then(() => parcelRequire('1iHdE'));